import { Routes, Route, Navigate } from 'react-router-dom';
import HomeFR from './home/fr/Home';
import HomeEN from './home/en/Home';
import Footer from './footer';

export default function App() {
  return (
    <>
    <Routes>
      <Route path="/" element={<Navigate to="/fr/home" replace />} />

      <Route path="/fr/home" element={<HomeFR />} />
      <Route path="/en/home" element={<HomeEN />} />

      <Route path="*" element={<Navigate to="/fr/home" replace />} />
    </Routes>
    <Footer/>
    </>
  );
}
